
import Vue from 'vue'

const locales = {keys(){return []}}
global['____A97B095____'] = true;
delete global['____A97B095____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"","navigationBarBackgroundColor":"#FFFFFF","backgroundColor":"#F8F8F8","navigationStyle":"custom"},"tabBar":{"custom":true,"list":[{"pagePath":"pages/index/index","text":"首页","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/category/category","text":"分类","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/shop_cart/shop_cart","text":"购物车","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/user/user","text":"个人中心","iconPath":"","selectedIconPath":"","redDot":false,"badge":""}],"color":"#999","selectedColor":"#007aff","backgroundColor":"","borderStyle":"black"},"easycom":{"autoscan":true,"custom":{"^u-(.*)":"@/components/uview-ui/components/u-$1/u-$1.vue","^w-(.*)":"@/components/widgets/$1/$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"condition":{"current":0,"list":[{"name":"","path":"","query":""}]}};
global.__uniConfig.compilerVersion = '4.75';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__A97B095';
global.__uniConfig.appName = '闪定商城';
global.__uniConfig.appVersion = '3.4.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/mobile/"};
global.__uniConfig.publicPath = "/mobile/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW"}}};
global.__uniConfig.qqMapKey = "FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-page-page', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/page/page"+'.vue')), 'pages-page-page'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-category-category', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/category/category"+'.vue')), 'pages-category-category'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop_cart-shop_cart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/shop_cart/shop_cart"+'.vue')), 'pages-shop_cart-shop_cart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/user/user"+'.vue')), 'pages-user-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-register-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/register/register"+'.vue')), 'pages-register-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-forget_pwd-forget_pwd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/forget_pwd/forget_pwd"+'.vue')), 'pages-forget_pwd-forget_pwd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-bind_mobile-bind_mobile', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/bind_mobile/bind_mobile"+'.vue')), 'pages-bind_mobile-bind_mobile'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_search-goods_search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/goods_search/goods_search"+'.vue')), 'pages-goods_search-goods_search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_detail-goods_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/goods_detail/goods_detail"+'.vue')), 'pages-goods_detail-goods_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_order-goods_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/goods_order/goods_order"+'.vue')), 'pages-goods_order-goods_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-payment-payment', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/payment/payment"+'.vue')), 'pages-payment-payment'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-payment_result-payment_result', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/payment_result/payment_result"+'.vue')), 'pages-payment_result-payment_result'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_detail-order_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/order_detail/order_detail"+'.vue')), 'pages-order_detail-order_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/address/address"+'.vue')), 'pages-address-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address_edit-address_edit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/address_edit/address_edit"+'.vue')), 'pages-address_edit-address_edit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-webview-webview', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/webview/webview"+'.vue')), 'pages-webview-webview'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-zw_design-zw_design', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/pages/zw_design/zw_design"+'.vue')), 'pages-zw_design-zw_design'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('components-uview-ui-components-u-avatar-cropper-u-avatar-cropper', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/components/uview-ui/components/u-avatar-cropper/u-avatar-cropper"+'.vue')), 'components-uview-ui-components-u-avatar-cropper-u-avatar-cropper'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_order-user_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_order/user_order"+'.vue')), 'bundle-pages-user_order-user_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-luck_draw_good-luck_draw_good', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/luck_draw_good/luck_draw_good"+'.vue')), 'bundle-pages-luck_draw_good-luck_draw_good'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_seckill-goods_seckill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_seckill/goods_seckill"+'.vue')), 'bundle-pages-goods_seckill-goods_seckill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_presell-goods_presell', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_presell/goods_presell"+'.vue')), 'bundle-pages-goods_presell-goods_presell'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-toAlipay-toAlipay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/toAlipay/toAlipay"+'.vue')), 'bundle-pages-toAlipay-toAlipay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_set-user_set', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_set/user_set"+'.vue')), 'bundle-pages-user_set-user_set'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-seckill_detail-seckill_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/seckill_detail/seckill_detail"+'.vue')), 'bundle-pages-seckill_detail-seckill_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-presell_detail-presell_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/presell_detail/presell_detail"+'.vue')), 'bundle-pages-presell_detail-presell_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_profile-user_profile', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_profile/user_profile"+'.vue')), 'bundle-pages-user_profile-user_profile'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_vip-user_vip', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_vip/user_vip"+'.vue')), 'bundle-pages-user_vip-user_vip'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_comment-goods_comment', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_comment/goods_comment"+'.vue')), 'bundle-pages-goods_comment-goods_comment'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_comment_he-goods_comment_he', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_comment_he/goods_comment_he"+'.vue')), 'bundle-pages-goods_comment_he-goods_comment_he'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-post_comment-post_comment', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/post_comment/post_comment"+'.vue')), 'bundle-pages-post_comment-post_comment'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-after_sale-after_sale', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/after_sale/after_sale"+'.vue')), 'bundle-pages-after_sale-after_sale'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-after_sale_detail-after_sale_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/after_sale_detail/after_sale_detail"+'.vue')), 'bundle-pages-after_sale_detail-after_sale_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-post_after_sale-post_after_sale', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/post_after_sale/post_after_sale"+'.vue')), 'bundle-pages-post_after_sale-post_after_sale'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-input_express_info-input_express_info', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/input_express_info/input_express_info"+'.vue')), 'bundle-pages-input_express_info-input_express_info'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-coupon-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/coupon/coupon"+'.vue')), 'bundle-pages-coupon-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-coupon_get-coupon_get', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/coupon_get/coupon_get"+'.vue')), 'bundle-pages-coupon_get-coupon_get'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_wallet-user_wallet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_wallet/user_wallet"+'.vue')), 'bundle-pages-user_wallet-user_wallet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_recharge-user_recharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_recharge/user_recharge"+'.vue')), 'bundle-pages-user_recharge-user_recharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-balance_transfer-balance_transfer', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/balance_transfer/balance_transfer"+'.vue')), 'bundle-pages-balance_transfer-balance_transfer'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_bill-user_bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_bill/user_bill"+'.vue')), 'bundle-pages-user_bill-user_bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-transfer_record-transfer_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/transfer_record/transfer_record"+'.vue')), 'bundle-pages-transfer_record-transfer_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_recharge_record-user_recharge_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_recharge_record/user_recharge_record"+'.vue')), 'bundle-pages-user_recharge_record-user_recharge_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_engry_recharge_record-user_engry_recharge_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_engry_recharge_record/user_engry_recharge_record"+'.vue')), 'bundle-pages-user_engry_recharge_record-user_engry_recharge_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-message_center-message_center', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/message_center/message_center"+'.vue')), 'bundle-pages-message_center-message_center'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-notice-notice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/notice/notice"+'.vue')), 'bundle-pages-notice-notice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-server_explan-server_explan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/server_explan/server_explan"+'.vue')), 'bundle-pages-server_explan-server_explan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-pay_pwd-pay_pwd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/pay_pwd/pay_pwd"+'.vue')), 'bundle-pages-pay_pwd-pay_pwd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-store_list-store_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/store_list/store_list"+'.vue')), 'bundle-pages-store_list-store_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-order_logistics-order_logistics', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/order_logistics/order_logistics"+'.vue')), 'bundle-pages-order_logistics-order_logistics'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_collects-goods_collects', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_collects/goods_collects"+'.vue')), 'bundle-pages-goods_collects-goods_collects'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-store_notice-store_notice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/store_notice/store_notice"+'.vue')), 'bundle-pages-store_notice-store_notice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-store_notice_detail-store_notice_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/store_notice_detail/store_notice_detail"+'.vue')), 'bundle-pages-store_notice_detail-store_notice_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_spread-user_spread', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_spread/user_spread"+'.vue')), 'bundle-pages-user_spread-user_spread'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-invite_poster-invite_poster', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/invite_poster/invite_poster"+'.vue')), 'bundle-pages-invite_poster-invite_poster'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_spread_order-user_spread_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_spread_order/user_spread_order"+'.vue')), 'bundle-pages-user_spread_order-user_spread_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_fans-user_fans', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_fans/user_fans"+'.vue')), 'bundle-pages-user_fans-user_fans'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-monthly_bill-monthly_bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/monthly_bill/monthly_bill"+'.vue')), 'bundle-pages-monthly_bill-monthly_bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-monthly_bill_detail-monthly_bill_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/monthly_bill_detail/monthly_bill_detail"+'.vue')), 'bundle-pages-monthly_bill_detail-monthly_bill_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-commission_details-commission_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/commission_details/commission_details"+'.vue')), 'bundle-pages-commission_details-commission_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_withdraw-user_withdraw', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_withdraw/user_withdraw"+'.vue')), 'bundle-pages-user_withdraw-user_withdraw'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-withdraw_success-withdraw_success', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/withdraw_success/withdraw_success"+'.vue')), 'bundle-pages-withdraw_success-withdraw_success'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-withdraw_record-withdraw_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/withdraw_record/withdraw_record"+'.vue')), 'bundle-pages-withdraw_record-withdraw_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-service-service', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/service/service"+'.vue')), 'bundle-pages-service-service'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-artificial_service-artificial_service', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/artificial_service/artificial_service"+'.vue')), 'bundle-pages-artificial_service-artificial_service'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_sign-user_sign', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_sign/user_sign"+'.vue')), 'bundle-pages-user_sign-user_sign'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_engry-user_engry', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_engry/user_engry"+'.vue')), 'bundle-pages-user_engry-user_engry'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-user_engry_recharge-user_engry_recharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/user_engry_recharge/user_engry_recharge"+'.vue')), 'bundle-pages-user_engry_recharge-user_engry_recharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-sign_rule-sign_rule', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/sign_rule/sign_rule"+'.vue')), 'bundle-pages-sign_rule-sign_rule'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-sign_detail-sign_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/sign_detail/sign_detail"+'.vue')), 'bundle-pages-sign_detail-sign_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-verification_detail-verification_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/verification_detail/verification_detail"+'.vue')), 'bundle-pages-verification_detail-verification_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-verification_list-verification_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/verification_list/verification_list"+'.vue')), 'bundle-pages-verification_list-verification_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_bargain-goods_bargain', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_bargain/goods_bargain"+'.vue')), 'bundle-pages-goods_bargain-goods_bargain'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-bargain_progress-bargain_progress', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/bargain_progress/bargain_progress"+'.vue')), 'bundle-pages-bargain_progress-bargain_progress'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-bargain_code-bargain_code', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/bargain_code/bargain_code"+'.vue')), 'bundle-pages-bargain_code-bargain_code'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_team-goods_team', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_team/goods_team"+'.vue')), 'bundle-pages-goods_team-goods_team'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_team_detail-goods_team_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_team_detail/goods_team_detail"+'.vue')), 'bundle-pages-goods_team_detail-goods_team_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-goods_team_history-goods_team_history', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/goods_team_history/goods_team_history"+'.vue')), 'bundle-pages-goods_team_history-goods_team_history'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-h5_pay_query-h5_pay_query', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/h5_pay_query/h5_pay_query"+'.vue')), 'bundle-pages-h5_pay_query-h5_pay_query'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-live_broadcast-live_broadcast', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/live_broadcast/live_broadcast"+'.vue')), 'bundle-pages-live_broadcast-live_broadcast'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-luck_draw-luck_draw', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/luck_draw/luck_draw"+'.vue')), 'bundle-pages-luck_draw-luck_draw'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-luck_draw_code-luck_draw_code', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/luck_draw_code/luck_draw_code"+'.vue')), 'bundle-pages-luck_draw_code-luck_draw_code'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-win_prize_code-win_prize_code', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/win_prize_code/win_prize_code"+'.vue')), 'bundle-pages-win_prize_code-win_prize_code'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-business_suspended-business_suspended', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/business_suspended/business_suspended"+'.vue')), 'bundle-pages-business_suspended-business_suspended'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-license-license', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/license/license"+'.vue')), 'bundle-pages-license-license'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-article_lists-article_lists', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/article_lists/article_lists"+'.vue')), 'bundle-pages-article_lists-article_lists'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-integral_mall-integral_mall', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/integral_mall/integral_mall"+'.vue')), 'bundle-pages-integral_mall-integral_mall'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-integral_goods_details-integral_goods_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/integral_goods_details/integral_goods_details"+'.vue')), 'bundle-pages-integral_goods_details-integral_goods_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-integral_settlement-integral_settlement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/integral_settlement/integral_settlement"+'.vue')), 'bundle-pages-integral_settlement-integral_settlement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-exchange_order-exchange_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/exchange_order/exchange_order"+'.vue')), 'bundle-pages-exchange_order-exchange_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-exchange_order_details-exchange_order_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/exchange_order_details/exchange_order_details"+'.vue')), 'bundle-pages-exchange_order_details-exchange_order_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-cancel-cancel', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/cancel/cancel"+'.vue')), 'bundle-pages-cancel-cancel'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-cancel_result-cancel_result', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/cancel_result/cancel_result"+'.vue')), 'bundle-pages-cancel_result-cancel_result'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-aiart_design-aiart_design', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/aiart_design/aiart_design"+'.vue')), 'bundle-pages-aiart_design-aiart_design'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-ai3d_design-ai3d_design', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/ai3d_design/ai3d_design"+'.vue')), 'bundle-pages-ai3d_design-ai3d_design'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-ai_history-ai_history', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/ai_history/ai_history"+'.vue')), 'bundle-pages-ai_history-ai_history'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-agent_goods_detail-agent_goods_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/agent_goods_detail/agent_goods_detail"+'.vue')), 'bundle-pages-agent_goods_detail-agent_goods_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('bundle-pages-owner_goods_detail-owner_goods_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/phpstudy_pro/WWW/MuHeShop/uniapp/bundle/pages/owner_goods_detail/owner_goods_detail"+'.vue')), 'bundle-pages-owner_goods_detail-owner_goods_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"首页","navigationStyle":"custom","enablePullDownRefresh":true})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/page/page',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"微页面"})
      },
      [
        createElement('pages-page-page', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-page-page',
  isNVue:false,maxWidth:0,
  pagePath:'pages/page/page',
  windowTop:0
}
},
{
path: '/pages/category/category',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分类","disableScroll":true,"navigationStyle":"custom","mp-alipay":{"allowsBounceVertical":"NO"}})
      },
      [
        createElement('pages-category-category', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-category-category',
  isNVue:false,maxWidth:0,
  pagePath:'pages/category/category',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/shop_cart/shop_cart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-shop_cart-shop_cart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-shop_cart-shop_cart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop_cart/shop_cart',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/user/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的","navigationStyle":"custom","enablePullDownRefresh":true})
      },
      [
        createElement('pages-user-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-user-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/user',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/register/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册","navigationStyle":"custom"})
      },
      [
        createElement('pages-register-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-register-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/register/register',
  windowTop:0
}
},
{
path: '/pages/forget_pwd/forget_pwd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码","navigationStyle":"custom"})
      },
      [
        createElement('pages-forget_pwd-forget_pwd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-forget_pwd-forget_pwd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/forget_pwd/forget_pwd',
  windowTop:0
}
},
{
path: '/pages/bind_mobile/bind_mobile',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机号"})
      },
      [
        createElement('pages-bind_mobile-bind_mobile', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-bind_mobile-bind_mobile',
  isNVue:false,maxWidth:0,
  pagePath:'pages/bind_mobile/bind_mobile',
  windowTop:0
}
},
{
path: '/pages/goods_search/goods_search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索"})
      },
      [
        createElement('pages-goods_search-goods_search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_search-goods_search',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_search/goods_search',
  windowTop:0
}
},
{
path: '/pages/goods_detail/goods_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情","navigationStyle":"custom"})
      },
      [
        createElement('pages-goods_detail-goods_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_detail-goods_detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_detail/goods_detail',
  windowTop:0
}
},
{
path: '/pages/goods_order/goods_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单结算"})
      },
      [
        createElement('pages-goods_order-goods_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_order-goods_order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_order/goods_order',
  windowTop:0
}
},
{
path: '/pages/payment/payment',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单支付"})
      },
      [
        createElement('pages-payment-payment', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-payment-payment',
  isNVue:false,maxWidth:0,
  pagePath:'pages/payment/payment',
  windowTop:0
}
},
{
path: '/pages/payment_result/payment_result',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付结果"})
      },
      [
        createElement('pages-payment_result-payment_result', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-payment_result-payment_result',
  isNVue:false,maxWidth:0,
  pagePath:'pages/payment_result/payment_result',
  windowTop:0
}
},
{
path: '/pages/order_detail/order_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","navigationStyle":"custom"})
      },
      [
        createElement('pages-order_detail-order_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_detail-order_detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_detail/order_detail',
  windowTop:0
}
},
{
path: '/pages/address/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址"})
      },
      [
        createElement('pages-address-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/address',
  windowTop:0
}
},
{
path: '/pages/address_edit/address_edit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"地址编辑"})
      },
      [
        createElement('pages-address_edit-address_edit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address_edit-address_edit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address_edit/address_edit',
  windowTop:0
}
},
{
path: '/pages/webview/webview',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-webview-webview', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-webview-webview',
  isNVue:false,maxWidth:0,
  pagePath:'pages/webview/webview',
  windowTop:0
}
},
{
path: '/pages/zw_design/zw_design',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-zw_design-zw_design', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-zw_design-zw_design',
  isNVue:false,maxWidth:0,
  pagePath:'pages/zw_design/zw_design',
  windowTop:0
}
},
{
path: '/components/uview-ui/components/u-avatar-cropper/u-avatar-cropper',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"头像裁剪","navigationBarBackgroundColor":"#000000"})
      },
      [
        createElement('components-uview-ui-components-u-avatar-cropper-u-avatar-cropper', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'components-uview-ui-components-u-avatar-cropper-u-avatar-cropper',
  isNVue:false,maxWidth:0,
  pagePath:'components/uview-ui/components/u-avatar-cropper/u-avatar-cropper',
  windowTop:0
}
},
{
path: '/bundle/pages/user_order/user_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单列表","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-user_order-user_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_order-user_order',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_order/user_order',
  windowTop:0
}
},
{
path: '/bundle/pages/luck_draw_good/luck_draw_good',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取奖品"})
      },
      [
        createElement('bundle-pages-luck_draw_good-luck_draw_good', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-luck_draw_good-luck_draw_good',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/luck_draw_good/luck_draw_good',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_seckill/goods_seckill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"限时秒杀"})
      },
      [
        createElement('bundle-pages-goods_seckill-goods_seckill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_seckill-goods_seckill',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_seckill/goods_seckill',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_presell/goods_presell',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预售精选"})
      },
      [
        createElement('bundle-pages-goods_presell-goods_presell', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_presell-goods_presell',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_presell/goods_presell',
  windowTop:0
}
},
{
path: '/bundle/pages/toAlipay/toAlipay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付宝支付"})
      },
      [
        createElement('bundle-pages-toAlipay-toAlipay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-toAlipay-toAlipay',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/toAlipay/toAlipay',
  windowTop:0
}
},
{
path: '/bundle/pages/user_set/user_set',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人资料"})
      },
      [
        createElement('bundle-pages-user_set-user_set', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_set-user_set',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_set/user_set',
  windowTop:0
}
},
{
path: '/bundle/pages/seckill_detail/seckill_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"秒杀详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-seckill_detail-seckill_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-seckill_detail-seckill_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/seckill_detail/seckill_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/presell_detail/presell_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预售详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-presell_detail-presell_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-presell_detail-presell_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/presell_detail/presell_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/user_profile/user_profile',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人设置"})
      },
      [
        createElement('bundle-pages-user_profile-user_profile', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_profile-user_profile',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_profile/user_profile',
  windowTop:0
}
},
{
path: '/bundle/pages/user_vip/user_vip',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员中心"})
      },
      [
        createElement('bundle-pages-user_vip-user_vip', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_vip-user_vip',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_vip/user_vip',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_comment/goods_comment',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"评价列表"})
      },
      [
        createElement('bundle-pages-goods_comment-goods_comment', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_comment-goods_comment',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_comment/goods_comment',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_comment_he/goods_comment_he',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部评价"})
      },
      [
        createElement('bundle-pages-goods_comment_he-goods_comment_he', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_comment_he-goods_comment_he',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_comment_he/goods_comment_he',
  windowTop:0
}
},
{
path: '/bundle/pages/post_comment/post_comment',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('bundle-pages-post_comment-post_comment', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-post_comment-post_comment',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/post_comment/post_comment',
  windowTop:0
}
},
{
path: '/bundle/pages/after_sale/after_sale',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后列表"})
      },
      [
        createElement('bundle-pages-after_sale-after_sale', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-after_sale-after_sale',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/after_sale/after_sale',
  windowTop:0
}
},
{
path: '/bundle/pages/after_sale_detail/after_sale_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后详情"})
      },
      [
        createElement('bundle-pages-after_sale_detail-after_sale_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-after_sale_detail-after_sale_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/after_sale_detail/after_sale_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/post_after_sale/post_after_sale',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请售后"})
      },
      [
        createElement('bundle-pages-post_after_sale-post_after_sale', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-post_after_sale-post_after_sale',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/post_after_sale/post_after_sale',
  windowTop:0
}
},
{
path: '/bundle/pages/input_express_info/input_express_info',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"填写快递单号"})
      },
      [
        createElement('bundle-pages-input_express_info-input_express_info', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-input_express_info-input_express_info',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/input_express_info/input_express_info',
  windowTop:0
}
},
{
path: '/bundle/pages/coupon/coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('bundle-pages-coupon-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-coupon-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/coupon/coupon',
  windowTop:0
}
},
{
path: '/bundle/pages/coupon_get/coupon_get',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领券中心"})
      },
      [
        createElement('bundle-pages-coupon_get-coupon_get', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-coupon_get-coupon_get',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/coupon_get/coupon_get',
  windowTop:0
}
},
{
path: '/bundle/pages/user_wallet/user_wallet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的钱包"})
      },
      [
        createElement('bundle-pages-user_wallet-user_wallet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_wallet-user_wallet',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_wallet/user_wallet',
  windowTop:0
}
},
{
path: '/bundle/pages/user_recharge/user_recharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户充值"})
      },
      [
        createElement('bundle-pages-user_recharge-user_recharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_recharge-user_recharge',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_recharge/user_recharge',
  windowTop:0
}
},
{
path: '/bundle/pages/balance_transfer/balance_transfer',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"余额转账"})
      },
      [
        createElement('bundle-pages-balance_transfer-balance_transfer', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-balance_transfer-balance_transfer',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/balance_transfer/balance_transfer',
  windowTop:0
}
},
{
path: '/bundle/pages/user_bill/user_bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账户明细"})
      },
      [
        createElement('bundle-pages-user_bill-user_bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_bill-user_bill',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_bill/user_bill',
  windowTop:0
}
},
{
path: '/bundle/pages/transfer_record/transfer_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"转账记录"})
      },
      [
        createElement('bundle-pages-transfer_record-transfer_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-transfer_record-transfer_record',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/transfer_record/transfer_record',
  windowTop:0
}
},
{
path: '/bundle/pages/user_recharge_record/user_recharge_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"充值记录"})
      },
      [
        createElement('bundle-pages-user_recharge_record-user_recharge_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_recharge_record-user_recharge_record',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_recharge_record/user_recharge_record',
  windowTop:0
}
},
{
path: '/bundle/pages/user_engry_recharge_record/user_engry_recharge_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"充值记录"})
      },
      [
        createElement('bundle-pages-user_engry_recharge_record-user_engry_recharge_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_engry_recharge_record-user_engry_recharge_record',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_engry_recharge_record/user_engry_recharge_record',
  windowTop:0
}
},
{
path: '/bundle/pages/message_center/message_center',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息中心"})
      },
      [
        createElement('bundle-pages-message_center-message_center', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-message_center-message_center',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/message_center/message_center',
  windowTop:0
}
},
{
path: '/bundle/pages/notice/notice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息列表"})
      },
      [
        createElement('bundle-pages-notice-notice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-notice-notice',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/notice/notice',
  windowTop:0
}
},
{
path: '/bundle/pages/server_explan/server_explan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"服务协议"})
      },
      [
        createElement('bundle-pages-server_explan-server_explan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-server_explan-server_explan',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/server_explan/server_explan',
  windowTop:0
}
},
{
path: '/bundle/pages/pay_pwd/pay_pwd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"交易密码"})
      },
      [
        createElement('bundle-pages-pay_pwd-pay_pwd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-pay_pwd-pay_pwd',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/pay_pwd/pay_pwd',
  windowTop:0
}
},
{
path: '/bundle/pages/store_list/store_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"自提门店","disableScroll":true,"mp-alipay":{"allowsBounceVertical":"NO"}})
      },
      [
        createElement('bundle-pages-store_list-store_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-store_list-store_list',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/store_list/store_list',
  windowTop:0
}
},
{
path: '/bundle/pages/order_logistics/order_logistics',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物流信息"})
      },
      [
        createElement('bundle-pages-order_logistics-order_logistics', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-order_logistics-order_logistics',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/order_logistics/order_logistics',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_collects/goods_collects',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的收藏"})
      },
      [
        createElement('bundle-pages-goods_collects-goods_collects', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_collects-goods_collects',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_collects/goods_collects',
  windowTop:0
}
},
{
path: '/bundle/pages/store_notice/store_notice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商城公告"})
      },
      [
        createElement('bundle-pages-store_notice-store_notice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-store_notice-store_notice',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/store_notice/store_notice',
  windowTop:0
}
},
{
path: '/bundle/pages/store_notice_detail/store_notice_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告详情"})
      },
      [
        createElement('bundle-pages-store_notice_detail-store_notice_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-store_notice_detail-store_notice_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/store_notice_detail/store_notice_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/user_spread/user_spread',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销推广"})
      },
      [
        createElement('bundle-pages-user_spread-user_spread', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_spread-user_spread',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_spread/user_spread',
  windowTop:0
}
},
{
path: '/bundle/pages/invite_poster/invite_poster',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请海报"})
      },
      [
        createElement('bundle-pages-invite_poster-invite_poster', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-invite_poster-invite_poster',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/invite_poster/invite_poster',
  windowTop:0
}
},
{
path: '/bundle/pages/user_spread_order/user_spread_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销订单"})
      },
      [
        createElement('bundle-pages-user_spread_order-user_spread_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_spread_order-user_spread_order',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_spread_order/user_spread_order',
  windowTop:0
}
},
{
path: '/bundle/pages/user_fans/user_fans',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的粉丝"})
      },
      [
        createElement('bundle-pages-user_fans-user_fans', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_fans-user_fans',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_fans/user_fans',
  windowTop:0
}
},
{
path: '/bundle/pages/monthly_bill/monthly_bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"月度账单"})
      },
      [
        createElement('bundle-pages-monthly_bill-monthly_bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-monthly_bill-monthly_bill',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/monthly_bill/monthly_bill',
  windowTop:0
}
},
{
path: '/bundle/pages/monthly_bill_detail/monthly_bill_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"月度账单明细"})
      },
      [
        createElement('bundle-pages-monthly_bill_detail-monthly_bill_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-monthly_bill_detail-monthly_bill_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/monthly_bill_detail/monthly_bill_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/commission_details/commission_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金明细"})
      },
      [
        createElement('bundle-pages-commission_details-commission_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-commission_details-commission_details',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/commission_details/commission_details',
  windowTop:0
}
},
{
path: '/bundle/pages/user_withdraw/user_withdraw',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提现"})
      },
      [
        createElement('bundle-pages-user_withdraw-user_withdraw', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_withdraw-user_withdraw',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_withdraw/user_withdraw',
  windowTop:0
}
},
{
path: '/bundle/pages/withdraw_success/withdraw_success',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提现详情"})
      },
      [
        createElement('bundle-pages-withdraw_success-withdraw_success', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-withdraw_success-withdraw_success',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/withdraw_success/withdraw_success',
  windowTop:0
}
},
{
path: '/bundle/pages/withdraw_record/withdraw_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提现记录"})
      },
      [
        createElement('bundle-pages-withdraw_record-withdraw_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-withdraw_record-withdraw_record',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/withdraw_record/withdraw_record',
  windowTop:0
}
},
{
path: '/bundle/pages/service/service',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"在线客服"})
      },
      [
        createElement('bundle-pages-service-service', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-service-service',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/service/service',
  windowTop:0
}
},
{
path: '/bundle/pages/artificial_service/artificial_service',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人工客服"})
      },
      [
        createElement('bundle-pages-artificial_service-artificial_service', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-artificial_service-artificial_service',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/artificial_service/artificial_service',
  windowTop:0
}
},
{
path: '/bundle/pages/user_sign/user_sign',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到"})
      },
      [
        createElement('bundle-pages-user_sign-user_sign', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_sign-user_sign',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_sign/user_sign',
  windowTop:0
}
},
{
path: '/bundle/pages/user_engry/user_engry',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"算力值"})
      },
      [
        createElement('bundle-pages-user_engry-user_engry', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_engry-user_engry',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_engry/user_engry',
  windowTop:0
}
},
{
path: '/bundle/pages/user_engry_recharge/user_engry_recharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"算力值"})
      },
      [
        createElement('bundle-pages-user_engry_recharge-user_engry_recharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-user_engry_recharge-user_engry_recharge',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/user_engry_recharge/user_engry_recharge',
  windowTop:0
}
},
{
path: '/bundle/pages/sign_rule/sign_rule',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到规则"})
      },
      [
        createElement('bundle-pages-sign_rule-sign_rule', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-sign_rule-sign_rule',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/sign_rule/sign_rule',
  windowTop:0
}
},
{
path: '/bundle/pages/sign_detail/sign_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分明细"})
      },
      [
        createElement('bundle-pages-sign_detail-sign_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-sign_detail-sign_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/sign_detail/sign_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/verification_detail/verification_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"核销详情"})
      },
      [
        createElement('bundle-pages-verification_detail-verification_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-verification_detail-verification_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/verification_detail/verification_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/verification_list/verification_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"核销订单"})
      },
      [
        createElement('bundle-pages-verification_list-verification_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-verification_list-verification_list',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/verification_list/verification_list',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_bargain/goods_bargain',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"砍价活动"})
      },
      [
        createElement('bundle-pages-goods_bargain-goods_bargain', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_bargain-goods_bargain',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_bargain/goods_bargain',
  windowTop:0
}
},
{
path: '/bundle/pages/bargain_progress/bargain_progress',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"砍价进度","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-bargain_progress-bargain_progress', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-bargain_progress-bargain_progress',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/bargain_progress/bargain_progress',
  windowTop:0
}
},
{
path: '/bundle/pages/bargain_code/bargain_code',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"砍价记录"})
      },
      [
        createElement('bundle-pages-bargain_code-bargain_code', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-bargain_code-bargain_code',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/bargain_code/bargain_code',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_team/goods_team',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"拼团活动"})
      },
      [
        createElement('bundle-pages-goods_team-goods_team', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_team-goods_team',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_team/goods_team',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_team_detail/goods_team_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-goods_team_detail-goods_team_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_team_detail-goods_team_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_team_detail/goods_team_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/goods_team_history/goods_team_history',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"拼团记录"})
      },
      [
        createElement('bundle-pages-goods_team_history-goods_team_history', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-goods_team_history-goods_team_history',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/goods_team_history/goods_team_history',
  windowTop:0
}
},
{
path: '/bundle/pages/h5_pay_query/h5_pay_query',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付查询"})
      },
      [
        createElement('bundle-pages-h5_pay_query-h5_pay_query', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-h5_pay_query-h5_pay_query',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/h5_pay_query/h5_pay_query',
  windowTop:0
}
},
{
path: '/bundle/pages/live_broadcast/live_broadcast',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"直播间"})
      },
      [
        createElement('bundle-pages-live_broadcast-live_broadcast', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-live_broadcast-live_broadcast',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/live_broadcast/live_broadcast',
  windowTop:0
}
},
{
path: '/bundle/pages/luck_draw/luck_draw',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分抽奖"})
      },
      [
        createElement('bundle-pages-luck_draw-luck_draw', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-luck_draw-luck_draw',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/luck_draw/luck_draw',
  windowTop:0
}
},
{
path: '/bundle/pages/luck_draw_code/luck_draw_code',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的奖品"})
      },
      [
        createElement('bundle-pages-luck_draw_code-luck_draw_code', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-luck_draw_code-luck_draw_code',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/luck_draw_code/luck_draw_code',
  windowTop:0
}
},
{
path: '/bundle/pages/win_prize_code/win_prize_code',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"中奖记录"})
      },
      [
        createElement('bundle-pages-win_prize_code-win_prize_code', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-win_prize_code-win_prize_code',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/win_prize_code/win_prize_code',
  windowTop:0
}
},
{
path: '/bundle/pages/business_suspended/business_suspended',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-business_suspended-business_suspended', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-business_suspended-business_suspended',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/business_suspended/business_suspended',
  windowTop:0
}
},
{
path: '/bundle/pages/license/license',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资质信息"})
      },
      [
        createElement('bundle-pages-license-license', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-license-license',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/license/license',
  windowTop:0
}
},
{
path: '/bundle/pages/article_lists/article_lists',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资讯列表"})
      },
      [
        createElement('bundle-pages-article_lists-article_lists', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-article_lists-article_lists',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/article_lists/article_lists',
  windowTop:0
}
},
{
path: '/bundle/pages/integral_mall/integral_mall',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分商城"})
      },
      [
        createElement('bundle-pages-integral_mall-integral_mall', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-integral_mall-integral_mall',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/integral_mall/integral_mall',
  windowTop:0
}
},
{
path: '/bundle/pages/integral_goods_details/integral_goods_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分兑换详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-integral_goods_details-integral_goods_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-integral_goods_details-integral_goods_details',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/integral_goods_details/integral_goods_details',
  windowTop:0
}
},
{
path: '/bundle/pages/integral_settlement/integral_settlement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分订单结算"})
      },
      [
        createElement('bundle-pages-integral_settlement-integral_settlement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-integral_settlement-integral_settlement',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/integral_settlement/integral_settlement',
  windowTop:0
}
},
{
path: '/bundle/pages/exchange_order/exchange_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换订单"})
      },
      [
        createElement('bundle-pages-exchange_order-exchange_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-exchange_order-exchange_order',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/exchange_order/exchange_order',
  windowTop:0
}
},
{
path: '/bundle/pages/exchange_order_details/exchange_order_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换订单详情"})
      },
      [
        createElement('bundle-pages-exchange_order_details-exchange_order_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-exchange_order_details-exchange_order_details',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/exchange_order_details/exchange_order_details',
  windowTop:0
}
},
{
path: '/bundle/pages/cancel/cancel',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销账号"})
      },
      [
        createElement('bundle-pages-cancel-cancel', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-cancel-cancel',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/cancel/cancel',
  windowTop:0
}
},
{
path: '/bundle/pages/cancel_result/cancel_result',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销账号"})
      },
      [
        createElement('bundle-pages-cancel_result-cancel_result', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-cancel_result-cancel_result',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/cancel_result/cancel_result',
  windowTop:0
}
},
{
path: '/bundle/pages/aiart_design/aiart_design',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"AI生成图片"})
      },
      [
        createElement('bundle-pages-aiart_design-aiart_design', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-aiart_design-aiart_design',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/aiart_design/aiart_design',
  windowTop:0
}
},
{
path: '/bundle/pages/ai3d_design/ai3d_design',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"AI生成3D模型"})
      },
      [
        createElement('bundle-pages-ai3d_design-ai3d_design', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-ai3d_design-ai3d_design',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/ai3d_design/ai3d_design',
  windowTop:0
}
},
{
path: '/bundle/pages/ai_history/ai_history',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('bundle-pages-ai_history-ai_history', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-ai_history-ai_history',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/ai_history/ai_history',
  windowTop:0
}
},
{
path: '/bundle/pages/agent_goods_detail/agent_goods_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选品设计商品详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-agent_goods_detail-agent_goods_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-agent_goods_detail-agent_goods_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/agent_goods_detail/agent_goods_detail',
  windowTop:0
}
},
{
path: '/bundle/pages/owner_goods_detail/owner_goods_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"定制模型商品详情","navigationStyle":"custom"})
      },
      [
        createElement('bundle-pages-owner_goods_detail-owner_goods_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'bundle-pages-owner_goods_detail-owner_goods_detail',
  isNVue:false,maxWidth:0,
  pagePath:'bundle/pages/owner_goods_detail/owner_goods_detail',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
